export default class EstatedMetadata {
  constructor(obj) {
    if (obj.metadata) {
      this.fips = obj.metadata.fips;
      this.apn = obj.metadata.apn;
      this.publishing_date = obj.metadata.publishing_date;
    }
  }
}
